import React from "react";
//import { ManageEmployeeContainer } from "../../../containers";
import { withAppLayout } from "../../../hoc";
import { ManageDistributionProvider } from "../../../contexts";
import ManageEmployeeDistribution from "../../../containers/Distribution/ManageEmployeeDistribution/ManageEmployeeDistribution";

const ManageDistribution = (props) => {
  return (
    <ManageDistributionProvider>
      <ManageEmployeeDistribution {...props} />
    </ManageDistributionProvider>
  );
};

export default withAppLayout(ManageDistribution);
